"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationCountTable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const function_1 = require("../../function");
function showAlert(message) {
    // 모든 input, textarea, select 요소에서 포커스를 해제
    // 모든 input, textarea 요소에서 포커스를 해제
    document.querySelectorAll('input, textarea').forEach(input => {
        input.blur();
    });
    // 포커스가 해제된 후 잠시 기다린 뒤 alert를 실행
    setTimeout(() => {
        alert(message);
    }, 100); // 100ms 정도 지연을 주어 키보드가 사라질 시간을 확보
}
exports.EvaluationCountTable = react_1.default.memo(({ evalItemCnt, evalData, subjectId, setEvalData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = react_1.default.useState(0);
    const [testData, setTestData] = react_1.default.useState([]);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [startNumber, setStartNumber] = react_1.default.useState(1); // 시작 문항번호 (자유형)
    // 기존 출제 데이터가 있으면 최소 문항번호로 시작번호 자동 복원
    react_1.default.useEffect(() => {
        const allIds = evalData
            .flatMap(e => (e.data || []).map((d) => Number(d.id)))
            .filter(n => Number.isFinite(n));
        if (allIds.length > 0)
            setStartNumber(Math.min(...allIds));
    }, [evalData]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'isCommon', space: 0.6, sort: false },
            { title: 'choiceSubject', space: 1, sort: false },
            { title: 'multipleChoice', space: 1, sort: false },
            { title: 'subjective', space: 1, sort: false },
        ];
        const tableReadDataKeys = [
            { title: 'isCommon', space: 0.6 },
            { title: 'choiceSubject', space: 1 },
            { title: 'multipleChoice', space: 1 },
            { title: 'subjective', space: 1 },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    const generateTestData = (count) => {
        const testDataArray = [];
        if (count >= evalData.length) {
            // initEvalData의 각 항목을 테스트 데이터로 변환
            evalData.forEach((item, index) => {
                testDataArray.push({
                    id: index,
                    choiceSubject: item.key,
                    multipleChoice: item.data
                        ? item.data.filter((data) => data.type === 'choice' || data.type === 'objective').length || 0
                        : 0,
                    subjective: item.data
                        ? item.data.filter((data) => data.type === 'short' || data.type === 'subjective').length || 0
                        : 0,
                });
            });
            // count가 initEvalData의 길이보다 큰 경우 추가 데이터를 생성
            for (let i = 0; i < count - evalData.length; i++) {
                testDataArray.push({
                    id: i + evalData.length,
                    choiceSubject: undefined,
                    multipleChoice: 1,
                    subjective: 1,
                });
            }
        }
        else {
            // count가 initEvalData의 길이보다 작은 경우
            for (let i = 0; i < count; i++) {
                testDataArray.push({
                    id: i,
                    choiceSubject: undefined,
                    multipleChoice: 1,
                    subjective: 1,
                });
            }
        }
        return testDataArray;
    };
    // 일반적인 기본값 생성
    react_1.default.useEffect(() => {
        const data = generateTestData(evalItemCnt);
        setTestData(data);
        setTotalCount(evalItemCnt);
    }, [evalItemCnt, subjectId, evalData]);
    // (OnClick) 항목 변경
    // (OnClick) 항목 변경
    const onChange = (id, changeData) => {
        if ((changeData.multipleChoice !== undefined && changeData.multipleChoice < 0) ||
            (changeData.subjective !== undefined && changeData.subjective < 0)) {
            showAlert('객관식/주관식 문항 수는 0보다 작을 수 없습니다. 문항 수를 조정해 주세요.');
            return;
        }
        setTestData(prevData => {
            const newData = prevData.map(item => {
                if (item.id === id) {
                    return { ...item, ...changeData };
                }
                return item; // 변경되지 않은 경우 이전 객체를 그대로 반환
            });
            return newData;
        });
    };
    // (onChange) 공통 체크 — 해당 행의 과목명을 '공통'으로 자동 입력(오타로 인식 실패 방지).
    // 공통 과목은 1개만 허용하므로, 체크 시 다른 행에 설정된 '공통'은 해제한다.
    const handlerSetCommon = (id, checked) => {
        setTestData(prevData => prevData.map(item => {
            if (item.id === id) {
                return { ...item, choiceSubject: checked ? '공통' : '' };
            }
            if (checked && item.choiceSubject === '공통') {
                return { ...item, choiceSubject: '' };
            }
            return item;
        }));
    };
    const renderEmpty = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "flex center body3 sel_eval_item", style: { color: Colors_1.Colors.light_grey } }, t('assignment.selectEvalCntItem')));
    }, []);
    // (onLoad) 데이터 불러오기
    const handlerMoreData = () => {
        setPage(prevPage => prevPage + 1);
    };
    // (onSort) 정렬하기
    const handlerUpdateList = (sort, desc) => {
        // get data from server
        setTestData(lodash_1.default.orderBy(testData, [sort], [desc ? 'desc' : 'asc']));
    };
    function compareData(data1, data2) {
        if (data1.length !== data2.length) {
            return false;
        }
        function normalizeType(type) {
            if (type === 'objective' || type === 'choice') {
                return 'objective';
            }
            if (type === 'subjective' || type === 'short') {
                return 'subjective';
            }
            return type;
        }
        for (let i = 0; i < data1.length; i++) {
            // Compare ids
            if (data1[i].id !== data2[i].id) {
                return false;
            }
            if (normalizeType(data1[i].type) !== normalizeType(data2[i].type)) {
                return false;
            }
        }
        return true;
    }
    // (onClick) 평가 항목 등록
    const onSubmit = () => {
        let isCheck = true;
        let newEvalData = new Map();
        let failData = [];
        // Set to track unique choiceSubject values
        const processedSubjects = new Set();
        // Iterate through updatedData without early termination
        for (const item of testData) {
            if (item.multipleChoice === 0 && item.subjective === 0) {
                showAlert('객관식/주관식 문항 수를 입력해주세요');
                isCheck = false;
                failData.push(item);
                continue;
            }
            // Check if values are in the range and if choiceSubject exists
            if (item.multipleChoice < 0 || item.subjective < 0) {
                showAlert('객관식/주관식 문항 수는 0보다 작을 수 없습니다. 문항 수를 조정해 주세요.');
                isCheck = false;
                failData.push(item);
                continue;
            }
            if (item.multipleChoice > 150 || item.subjective > 150) {
                showAlert('객관식/주관식 문항 수는 최대 150문항을 초과할 수 없습니다. 문항 수를 조정해 주세요.');
                isCheck = false;
                failData.push(item);
                continue;
            }
            if (item.choiceSubject === undefined || item.choiceSubject.trim() === '') {
                showAlert('과목 이름을 입력해주세요');
                isCheck = false;
                failData.push(item);
                continue;
            }
            // Check for duplicate choiceSubject
            if (processedSubjects.has(item.choiceSubject)) {
                showAlert(`중복된 과제 이름이 있습니다: ${item.choiceSubject}`);
                isCheck = false;
                failData.push(item);
                continue;
            }
            // Add the current choiceSubject to the Set
            processedSubjects.add(item.choiceSubject);
            // Create data and set in evalData
            const data = (0, function_1.createFreeEvalArray)(item.multipleChoice, item.subjective, startNumber);
            if (evalData.length === 0) {
                newEvalData.set(item.choiceSubject, { key: item.choiceSubject, data });
            }
            else {
                const existingItem = evalData.find(data => data.key === item.choiceSubject);
                if (existingItem === undefined) {
                    newEvalData.set(item.choiceSubject, { key: item.choiceSubject, data });
                }
                else {
                    const evalDataItem = existingItem.data;
                    if (compareData(data, evalDataItem)) {
                        newEvalData.set(item.choiceSubject, {
                            key: item.choiceSubject,
                            data: evalDataItem,
                        });
                    }
                    else {
                        newEvalData.set(item.choiceSubject, { key: item.choiceSubject, data });
                    }
                }
            }
        }
        // If all data is valid, proceed
        if (isCheck) {
            console.log([...newEvalData.values()]);
            setEvalData([...newEvalData.values()]); // Assuming evalData needs to be an array
            // Handle mobile-specific logic
            if (isMobile) {
                if (testData.length === [...newEvalData.values()].length) {
                    showAlert('등록 되었습니다');
                }
            }
        }
        else {
            // // When validation fails, filter out the invalid data from updatedData
            // const validData = updatedData.filter(data => !failData.includes(data));
            // // Update the evalData with valid entries
            // setEvalData(
            // 	validData.map(data => ({
            // 		key: data.choiceSubject,
            // 		data: createFreeEvalArray(data.multipleChoice, data.subjective),
            // 	}))
            // );
            // alert('입력값에 문제가 있는 항목은 제외되었습니다.');
        }
    };
    const renderItem = (item, styles) => {
        return (react_1.default.createElement(EvalCountItem, { item: item, tabelReadDataKeys: tableReadDataKeys, styles: styles, onChange: onChange, onToggleCommon: handlerSetCommon }));
    };
    return (react_1.default.createElement("div", { className: "popup-list-002-wrapper" },
        react_1.default.createElement(common_1.Table, { className: "popup-list-002", renderTitle: evalItemCnt !== 0 ? (react_1.default.createElement("div", { className: "eval-start-number", style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 12px',
                    borderBottom: '1px solid #e0e3e8',
                } },
                react_1.default.createElement("span", { className: "overText2", style: { fontWeight: 600 } }, t('assignment.startQuestionNumber')),
                react_1.default.createElement(common_1.InputElement, { type: "number", min: 1, value: String(startNumber), onChange: v => setStartNumber(Math.max(1, Number(v) || 1)), style: { width: '90px' } }))) : undefined, showCheckBox: false, showIndex: false, isInfinite: true, data: testData, totalCount: totalCount, page: page, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem, renderEmpty: evalItemCnt === 0 && renderEmpty, handlerMoreData: handlerMoreData, handlerUpdateList: handlerUpdateList, styles: {
                scrollContent: {
                    justifyContent: evalItemCnt === 0 && 'center',
                    minHeight: evalItemCnt === 0 && isDesktop && '100px',
                },
            }, forceShowheader: isMobile && evalItemCnt === 0 ? false : true }),
        evalItemCnt !== 0 && (react_1.default.createElement(common_1.Button, { text: "common.okay", className: `btn_line_tur ${isTablet || isMobile ? 'xxs' : 'sm'}`, styles: {
                buttonWrap: {
                    width: isMobile ? '100%' : 'unset',
                },
            }, onClick: onSubmit }))));
});
const EvalCountItem = react_1.default.memo(({ item, tabelReadDataKeys, styles, onChange, onToggleCommon, }) => {
    const choiceSubjectRef = (0, react_1.useRef)(null);
    const multipleChoiceRef = (0, react_1.useRef)(null);
    const subjectiveRef = (0, react_1.useRef)(null);
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    react_1.default.useEffect(() => {
        if (choiceSubjectRef.current) {
            choiceSubjectRef.current.value = item.choiceSubject || '';
        }
    }, [item.choiceSubject]);
    react_1.default.useEffect(() => {
        if (multipleChoiceRef.current) {
            multipleChoiceRef.current.valueAsNumber = Number(item.multipleChoice);
        }
    }, [item.multipleChoice]);
    react_1.default.useEffect(() => {
        if (subjectiveRef.current) {
            subjectiveRef.current.valueAsNumber = Number(item.subjective);
        }
    }, [item.subjective]);
    return (react_1.default.createElement(react_1.default.Fragment, null, tabelReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
            flex: headItem.space,
            ...styles?.bodyItem,
            overflow: 'hidden',
            // 공통 체크박스 셀은 행 높이를 채워 정중앙 정렬 (.body-item 기본 높이 미적용 대응)
            ...(headItem.title === 'isCommon'
                ? {
                    alignSelf: 'stretch',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
                : {}),
        } }, headItem.title === 'isCommon' ? (react_1.default.createElement("label", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0,
            cursor: 'pointer',
        } },
        react_1.default.createElement("input", { type: "checkbox", checked: item.choiceSubject === '공통', onChange: e => onToggleCommon(item.id, e.target.checked), style: { display: 'none' } }),
        react_1.default.createElement(common_1.Icon, { icon: item.choiceSubject === '공통' ? 'checked' : 'unchecked', size: 22, fill: Colors_1.Colors.transparent, style: { display: 'block' } }))) : headItem.title === 'choiceSubject' ? (react_1.default.createElement(common_1.InputElement, { ref: choiceSubjectRef, className: "input-md", type: "text", 
        // 공통 체크 시 '공통' 고정 — 직접 수정 방지(체크 해제하면 편집 가능)
        isDisable: item.choiceSubject === '공통', placeholder: isMobile
            ? '과목 입력'
            : t(`assignment.${headItem.title}Placeholder`), style: styles?.bodyText, onChange: value => onChange(item.id, { [headItem.title]: value }), min: 0 })) : (react_1.default.createElement(common_1.InputElement, { ref: headItem.title === 'multipleChoice'
            ? multipleChoiceRef
            : subjectiveRef, className: "input-md", type: "number", placeholder: t(`assignment.${headItem.title}Placeholder`), style: styles?.bodyText, onChange: value => onChange(item.id, {
            [headItem.title]: Number(value),
        }), min: 0 })))))));
});
